'use client'

type ErrorMessageProps = {
  error: Error
  resetErrorBoundary: () => void
}

function ProductionErrorMessage() {
  return <p>🌀 Something went wrong...</p>
}

const prepareErrorMessage = (error: Error) => {
  const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'test'

  if (isDevelopment) {
    return <p>{error.message}</p>
  }

  return <ProductionErrorMessage />
}

export function ErrorMessage({ error }: { error: Error | unknown }) {
  const message = prepareErrorMessage(error instanceof Error ? error : new Error(String(error || 'Unknown error')))

  return (
    <div className="rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700">
      <h2>Error</h2>
      <div>{message}</div>
    </div>
  )
}
